import {
  RiMapPinLine,
  RiTeamLine,
  RiTrophyLine,
  RiHandHeartLine,
  RiLineChartLine,
  RiCustomerService2Line
} from "@remixicon/react"

export default function CharlestonWhyUs() {
  const reasons = [
    {
      icon: RiMapPinLine,
      title: "Charleston Experts",
      description: "We're based in Charleston and deeply understand the local market, culture, and what resonates with Lowcountry customers.",
    },
    {
      icon: RiTeamLine,
      title: "Small Business Focus",
      description: "We specialize in working with small businesses, providing enterprise level marketing without the enterprise price tag.",
    },
    {
      icon: RiLineChartLine,
      title: "Proven Results",
      description: "Our clients see average increases of 250% in website traffic and 180% in qualified leads within the first 6 months.",
    },
    {
      icon: RiHandHeartLine,
      title: "Personalized Service",
      description: "No cookie cutter solutions. Every strategy is custom built for your unique business goals and target audience.",
    },
    {
      icon: RiTrophyLine,
      title: "Trusted by Many",
      description: "Join the growing number of businesses that trust us to deliver results. Our proven track record speaks for itself.",
    },
    {
      icon: RiCustomerService2Line,
      title: "Always Available",
      description: "Direct access to your dedicated account manager. No call centers, no ticket systems, just real people who care.",
    },
  ]

  return (
    <section
      aria-label="Why Choose Us"
      id="why-us"
      className="relative mx-auto max-w-7xl px-4 scroll-my-24"
    >
      {/* Background decoration */}
      <div className="absolute inset-0 -z-10 overflow-hidden">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-gradient-to-br from-[#003566]/5 to-[#ffc300]/5 rounded-full blur-3xl" />
      </div>

      <div className="text-center mb-16">
        <h2 className="relative inline-block text-lg font-semibold tracking-tight text-[#003566]">
          Why Choose Us
          <div className="absolute top-1 -left-[8px] h-5 w-[3px] rounded-r-sm bg-[#003566]" />
        </h2>
        <p className="mt-4 text-4xl font-semibold tracking-tighter text-balance text-gray-900 md:text-5xl">
          Your Partner in Digital Growth
        </p>
        <p className="mt-4 text-lg text-balance text-gray-700 max-w-3xl mx-auto">
          We're not just another marketing agency. We're your neighbors, invested in the success of Charleston's local business community.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        {reasons.map((reason, index) => {
          const Icon = reason.icon
          return (
            <div
              key={index}
              className="relative group"
            >
              <div className="absolute inset-0 bg-gradient-to-br from-[#003566]/5 to-transparent rounded-2xl transition-all duration-300 group-hover:from-[#003566]/10" />

              <div className="relative p-8">
                <div className="inline-flex items-center justify-center rounded-full bg-white border-2 border-[#003566]/10 p-4 shadow-sm group-hover:border-[#003566]/20 transition-all duration-300">
                  <Icon className="size-8 text-[#003566]" />
                </div>

                <h3 className="mt-6 text-xl font-semibold text-gray-900">
                  {reason.title}
                </h3>

                <p className="mt-3 text-gray-600 leading-relaxed">
                  {reason.description}
                </p>
              </div>
            </div>
          )
        })}
      </div>

    </section>
  )
}
